export enum AlertLevelType {
  'WEAK' = 'WEAK',
  'MEDIUM' = 'MEDIUM',
  'STRONG' = 'STRONG',
}

export const AlertTypes: AlertLevelType[] = [AlertLevelType.WEAK, AlertLevelType.MEDIUM, AlertLevelType.STRONG];
